<div class="app-content" #appContent>
    <router-outlet></router-outlet>
</div>

<div id="context-menu-placeholder" #contextMenuPlaceholder></div>
